// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import 'element-theme-chalk/lib/loading.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import cssVars from 'css-vars-ponyfill'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueSession from 'vue-session'
import jwtDecode from 'jwt-decode'
import ElementLoading from 'element-ui/packages/loading'
import VueSweetalert2 from 'vue-sweetalert2';

import App from './App'
import router from './router'
import API from './api'
import EventBus from './shared/event-bus'

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(ElementLoading)
Vue.use(VueSweetalert2)

// Session
VueSession.key = 'adreplay-session'
VueSession.flash_key = 'adreplay-flash'
Vue.use(VueSession, {
  persist: true
})
const $session = new Vue().$session

// API config
const $API = new API($session)
Vue.prototype.$API = $API

// Router auth
router.beforeEach((to, from, next) => {
  const needsLogin = () => {
    const query = ['/', '/dashboard'].indexOf(to.fullPath) === -1 ? { redirect: to.fullPath } : {}
    next({
      path: '/login',
      query
    })
  }

  // Auth required
  if(!to.matched.some(record => record.meta.auth)) {
    next()
    return
  }

  const token = $session.get('token')

  // No token, login
  if(!token) {
    needsLogin()
    return
  }

  next()
})

var $loading = document.getElementById('loading')
router.afterEach(() => {
  if(!$loading) {
    return
  }

  // Dismiss global loading overlay
  $loading.style.opacity = 0
  setTimeout(() => {
    $loading.parentNode.removeChild($loading)
    $loading = null
  }, 400)
})

// Session
Vue.prototype.$session.setToken = function (token) {
  const claims = jwtDecode(token)

  this.set('token', token)
  Object.keys(claims).forEach((key) => {
    this.set(key, claims[key])
  })
  EventBus.$emit('session.token', token)
}

Vue.prototype.$session.getLimit = function (key, defaultValue = '') {
  const limits = this.get('limits')
  return limits[key] || defaultValue
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
